import React, { PropsWithChildren, useEffect, useMemo } from "react";
import { AuthManagerContext, AuthStatus } from "./AuthManager";
import { useFonts } from "expo-font";
import * as SplashScreen from "expo-splash-screen";
import Loading from "../components/Loading";
import { ProfileSwitcherManagerContext } from "./ProfileSwitcherManager";

export const useLiftFont = () => {
    return useFonts({
        "Jubilat-Light": require("../assets/fonts/Jubilat-Light.otf"),
        "Jubilat-Regular": require("../assets/fonts/Jubilat-Regular.otf"),
        "Jubilat-Medium": require("../assets/fonts/Jubilat-Medium.otf"),
        "Jubilat-Bold": require("../assets/fonts/Jubilat-Bold.otf"),
        "Jubilat-LightItalic": require("../assets/fonts/Jubilat-LightItalic.otf"),
        "Jubilat-RegularItalic": require("../assets/fonts/Jubilat-RegularItalic.otf"),
        "Inter-Regular": require("../assets/fonts/Inter-Regular.otf"),
        "Inter-SemiBold": require("../assets/fonts/Inter-SemiBold.otf"),
        "Inter-Bold": require("../assets/fonts/Inter-Bold.otf"),
        "Inter-Italic": require("../assets/fonts/Inter-Italic.otf"),
        "Inter-BoldItalic": require("../assets/fonts/Inter-BoldItalic.otf"),
        "SpaceMono-Regular": require("../assets/fonts/SpaceMono-Regular.ttf"),
        "SpaceMono-Bold": require("../assets/fonts/SpaceMono-Bold.ttf"),
        "SpaceMono-Italic": require("../assets/fonts/SpaceMono-Italic.ttf"),
        "SpaceMono-BoldItalic": require("../assets/fonts/SpaceMono-BoldItalic.ttf"),
    });
};

const AppLoadingManager: React.FC<PropsWithChildren> = ({ children }) => {
    const { status } = React.useContext(AuthManagerContext);
    const { profileType, switchingProfile } = React.useContext(ProfileSwitcherManagerContext);
    const [fontsLoaded, fontsError] = useLiftFont();

    const isAppLoaded = useMemo(
        () =>
            (fontsLoaded || fontsError) &&
            !switchingProfile &&
            (status === AuthStatus.Out || (status === AuthStatus.In && profileType)),
        [switchingProfile, fontsError, fontsLoaded, profileType, status],
    );

    useEffect(() => {
        if (fontsError) {
            throw fontsError;
        }
    }, [fontsError]);

    useEffect(() => {
        if (isAppLoaded) {
            // ATTENTION do not delay this call, it will break the navigation container on case we need to display
            // the modal for the push notification
            void SplashScreen.hideAsync();
        }
    }, [isAppLoaded]);

    // we need to wait fonts are loading before displaying shildren otherwise some screens won't have fonts
    return isAppLoaded ? children : <Loading style={{ flex: 1 }} />;
};

export default AppLoadingManager;
